module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div>\n    <div class="content-container">\n        <section class="row">\n            <div class="col-md-5">\n                <div class="icon-picker-label">\n                    Icon\n                </div>\n            </div>\n            <div class="col-md-7 properties-view-picker-container">\n                <div class="icons-selection-region"></div>\n                <div class="zmags-input-control placement-options-container">\n                    <select class="placement-select form-control">\n                        <option value="' +
__e( Placement.AFTER ) +
'">After</option>\n                        <option value="' +
__e( Placement.BEFORE ) +
'">Before</option>\n                    </select>\n                </div>\n            </div>\n        </section>\n\n        <div class="zmags-input-control">\n            <section class="row properties color-section">\n                <div class="col-md-5">\n                    Icon Color\n                </div>\n                <div class="col-md-7">\n                    <div class="color-info">\n                        <div class="icon-color-box color-box"></div>\n                        <input type="text" class="button-icon-color-input color-input-box" />\n                    </div>\n                </div>\n            </section>\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/button/IconPropertiesView.tpl
// module id = 1758
// module chunks = 0